<template>
  <div class="base-info">
    <formTemplate :title="'商品详情介绍'" :formData="detail_info">
      <template v-slot:body>
        <el-form-item label="1:1主页轮播图">
          <div class="primary-flex">
            <dyhUpload ref="dyhUploadRef" @dyhUploadReturn="dyhUploadReturn" :count="5"></dyhUpload>
          </div>
        </el-form-item>
        <!-- <el-form-item label="3:4商品详情图">
          <div class="primary-flex">
            <dyhUpload @dyhUploadReturn="dyhUploadReturn" :count="5"></dyhUpload>
          </div>
        </el-form-item> -->
        <el-form-item label="商品属性" class="primary-flex">
          <div class="primary-flex dyh-line-group" style="margin-left: -120px !important;">
            <div class="label">属性名</div>
            <div><el-input v-model="attribute_data.key" placeholder="属性名"></el-input></div>
            <div class="label margin-left-sm">属性值</div>
            <div><el-input v-model="attribute_data.value" placeholder="属性值"></el-input></div>
            <el-button type="primary" size="" plain @click="addAttribute" style="margin-left:10px">
              <i class="el-icon-plus"></i> 新增属性
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="商品详细属性" v-if="Object.keys(detail_info.attribute_json).length > 0">
          <div class="primary-flex">
            <div style="margin-right: 10px;" v-for="(value, key) in detail_info.attribute_json" :key="key">
              <el-tag>{{ key }}: {{ value }}</el-tag>
            </div>
          </div>

        </el-form-item>
        <el-form-item label="商品详细描述">
          <dyhWangEditor ref="dyhWangEditorRef" @wangEditorChange="wangEditorChange"></dyhWangEditor>
        </el-form-item>
        <el-button @click="Cons"> 输出</el-button>
      </template>
    </formTemplate>
  </div>

</template>
<script>
import { basicDownLoadImg } from '@/api/basic.js';
import formTemplate from './formTemplate.vue';
import dyhUpload from '@/components/dyhUpload.vue';
import dyhWangEditor from '@/components/dyh-wangEditor.vue';

export default {
  name: 'detailInfo',
  components: {
    formTemplate, dyhUpload, dyhWangEditor
  },
  data() {
    return {
      attribute_data: {
        key: "",
        value: ""
      },
      detail_info: {
        attribute_json: {},
        goods_label: "",
        banner: []
      }
    };
  },
  methods: {
    Cons() {
      console.log(this.detail_info);
    },
    /**
     * 通过media_no下载图片
     * @param {string} media_no 64位字符串
     */
    async mediaNoGetUrl(media_no) {
      let url = "data:image/png;base64," + (await basicDownLoadImg(media_no));
      /* this.view_url.push(url); */
      return url;
    },
    getValue() {
      return this.detail_info;
    },
    async setValue(v) {
      this.detail_info = v;
      if (v.goods_label) {
        this.$refs.dyhWangEditorRef.setHtml(v.goods_label);
      }
      if (v.banner) {
        const banner = v.banner;
        console.log("banner-------------------------", banner);
        let list = [];
        try {
          for (let i = 0; i < banner.length; i++) {
            if (banner[i] && banner[i].url.indexOf("http") === -1 && banner[i].url.length === 64) {
              list.push({
                media_no: banner[i].url,
                url: await this.mediaNoGetUrl(banner[i].url)
              });
              /* await this.mediaNoGetUrl(banner[i].url)); */
            } else {
              list.push({
                url: banner[i].url
              });
            }
          }
          console.log("list-------------------------", list);
        } catch (e) {
          console.log("eeeeeeeee", e);
        }

        this.$refs.dyhUploadRef.setBaseImage(list);
      }
    },
    wangEditorChange(html) {
      this.detail_info.goods_label = html;
    },
    /**
     * 新增属性
     */
    addAttribute() {
      if (this.attribute_data.key && this.attribute_data.value) {
        this.$set(this.detail_info.attribute_json, this.attribute_data.key, this.attribute_data.value);
        // 清空输入框
        this.attribute_data.key = "";
        this.attribute_data.value = "";
      } else {
        this.$message.warning("请填写完整的属性名和属性值");
      }
    },
    dyhUploadReturn(v) {
      console.log("v", v);
      this.detail_info.banner = [];
      for (let i = 0; i < v.imageList.length; i++) {
        if (v.imageList[i] && ((v.imageList[i].media_no && v.imageList[i].media_no.length > 0) || (v.imageList[i].url && v.imageList[i].url.length > 0))) {
          this.detail_info.banner.push(v.imageList[i]);
        }
      }
      console.log("detail_info.banner", this.detail_info.banner);
    }
  }
};
</script>
<style lang="less" scoped>
.label {
  width: 80px;
  height: auto;
  text-align: left;
}
</style>